import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { 
  getAuthToken, 
  setQRCodeData, 
  getQRCodeUrl, 
  getQRCodeLocationName 
} from "../utils/cookieUtils";
import { useLocations } from "../hooks/useLocations";

function QrCode() {
  const { locations, loading: loadingLocations } = useLocations(true);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [url, setUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formLocation, setFormLocation] = useState("");
  const [selectedLocationName, setSelectedLocationName] = useState(""); 

  const getToken = () => {
    const token = getAuthToken();
    if (!token) {
      console.error("No access token found");
      setIsLoading(false);
    }
    return token;
  };

  const handleError = (error) => {
    let message = "An error occurred while fetching QR code.";
    if (error.response) {
      message = error.response.data?.message || message;
    } else if (error.request) {
      message = "No response from server.";
    } else if (error.message) {
      message = error.message;
    }
    toast.error(message);
    setIsLoading(false);
  };

  const fetchQrCode = (locationId) => {
    const token = getToken();
    if (!token || !locationId) return;

    setIsLoading(true);
    axios
      .get(`/super-admin/get-qr-code?location_id=${locationId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const msgArr = response.data.message;
        if (Array.isArray(msgArr) && msgArr.length > 0) {
          const qrCodePath = msgArr[0].qr_code_path;
          const locationName = msgArr[0].location?.name || "";
          setUrl(qrCodePath);
          setSelectedLocationName(locationName);
          setQRCodeData(locationId, qrCodePath, locationName);
        }
        setIsLoading(false);
      })
      .catch(handleError);
  };

  const regenerateQr = () => {
    const token = getToken();
    if (!token || !selectedLocation) return;

    setIsLoading(true);
    axios
      .post(
        `/super-admin/generate-qr-code?location_id=${selectedLocation}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const qrCodePath = response.data.message.path;
        setUrl(qrCodePath);
        setQRCodeData(selectedLocation, qrCodePath);
        setIsLoading(false);
        toast.success("QR successfully refreshed");
      })
      .catch(handleError);
  };

  // When location is selected, fetch QR code
  useEffect(() => {
    if (!selectedLocation) return;
    const cachedUrl = getQRCodeUrl(selectedLocation);
    const cachedName = getQRCodeLocationName(selectedLocation);
    if (cachedUrl) {
      setUrl(cachedUrl);
      setSelectedLocationName(cachedName || "");
      setIsLoading(false);
    } else {
      fetchQrCode(selectedLocation);
    }
  }, [selectedLocation]);

  const handleDownload = () => {
    window.open(url, "_blank");
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  if (!selectedLocation) {
    return (
<div className="dashboard" >
  <div className="Nav">
    <Sidebar />
  </div>
  <div
    className="dashboard-display"
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh",
      height: "100vh",
    }}
  >
    
    <form
      style={{
        background: "#fff",
        padding: "40px 32px",
        borderRadius: "16px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        minWidth: "320px",
        maxWidth: "420px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "all 0.2s ease-in-out",
      }}
      onSubmit={async (e) => {
        e.preventDefault();
        if (selectedLocation) return;
        if (formLocation) {
          setIsLoading(true);
          setSelectedLocation(formLocation);
          await fetchQrCode(formLocation);
          setIsLoading(false);
        }
      }}
    >
      <h2
        style={{
          marginBottom: "24px",
          fontSize: "22px",
          fontWeight: "600",
          textAlign: "center",
          color: "#333",
        }}
      >
        Enter Gym Location
      </h2>

      <select
        style={{
          width: "100%",
          marginBottom: "24px",
          padding: "12px",
          fontSize: "16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          background: "#fafafa",
          outline: "none",
          transition: "border-color 0.2s",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#007bff")}
        onBlur={(e) => (e.target.style.borderColor = "#ccc")}
        disabled={loadingLocations || isLoading}
        value={formLocation || ""}
        onChange={(e) => setFormLocation(e.target.value)}
        required
      >
        <option value="" disabled>
          {loadingLocations ? "Loading locations..." : "Select a location"}
        </option>
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>
            {loc.name}
          </option>
        ))}
      </select>

      <button
        type="submit"
        style={{
          padding: "12px",
          fontSize: "16px",
          fontWeight: "500",
          width: "100%",
          background: isLoading ? "#6c757d" : "#0473bd",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: isLoading ? "not-allowed" : "pointer",
          transition: "background 0.3s",
        }}
        onMouseEnter={(e) => {
          if (!isLoading) e.target.style.background = "#0056b3";
        }}
        onMouseLeave={(e) => {
          if (!isLoading) e.target.style.background = "#007bff";
        }}
        disabled={loadingLocations || !formLocation || isLoading}
      >
        {isLoading ? (
          <div
            className="spinner"
            style={{
              height: "20px",
              width: "20px",
              border: "3px solid #fff",
              borderTop: "3px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto",
            }}
          ></div>
        ) : (
          "Get QR"
        )}
      </button>
    </form>
  </div>
</div>

    );
  }

  // Get selected location name (prefer from API, fallback to locations array)
  const selectedLocationObj = locations.find(
    (l) => String(l.id) === String(selectedLocation)
  );
  const displayLocationName = selectedLocationName || (selectedLocationObj ? selectedLocationObj.name : "QR Code");

  return (
    <div className="dashboard">
      <div className="Nav">
        <Sidebar />
      </div>
      <div className="dashboard-display">
        <div className="top-bar container-fluid">
          <div
            className="top-bar-info"
            style={{ display: "flex", alignItems: "center" }}
          >
            <b>
              <p style={{ margin: 0 }}>Generate QR code</p>
            </b>
          </div>
        </div>
        <div className="main-qr">
          <div className="qr-body">
            <h1>
              {displayLocationName} Gym QR Code
            </h1>
            <div className="qr-container">
              {isLoading ? (
                <div className="spinner"></div>
              ) : url ? (
                <img
                  src={url}
                  alt="QR Code"
                  style={{ display: "block" }}
                  onLoad={handleImageLoad}
                />
              ) : (
                <div style={{ textAlign: "center", color: "#aaa", padding: "24px" }}>
                  <div style={{ fontSize: 48, marginBottom: 8 }}>
                    <img src={`${process.env.PUBLIC_URL}/images/no-qr.png`} alt="No QR code available" /></div>
                  <div>No QR code available</div>
                </div>
              )}
            </div>
            <br />
            <button
              onClick={() => {
                setIsLoading(true);
                regenerateQr();
              }}
            >
              Refresh QR Code
            </button>
            <br />
            <button onClick={handleDownload}>Download QR Code</button>
            <br />
            <button
              style={{
                marginTop: 16,
                background: "#0473bd",
                color: "white",
                border: "none",
                borderRadius: 4,
                padding: "6px 16px",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedLocation(null);
                setUrl("");
                setFormLocation("");
                setSelectedLocationName("");
              }}
            >
              Change Location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrCode;
